import { calculateHighestTee } from "../calculateHighestTee";

export const checkAdvantage = async (handicap, parIndexVal, value, advan) => {

  if (Object.keys(value).length > 0) {
    let tempGroupArr = [...value.group1, ...value.group2];

    let [t1, t2, t3, t4] = tempGroupArr;

    let highestTee = await calculateHighestTee(handicap)[0];
    let minTee = await calculateHighestTee(handicap)[1];

    for (let i = 0; i < handicap.length; i++) {
      if (handicap[i].advantage) {
        let advanPoint = highestTee[i][highestTee[i].default_tee] - minTee;

        advanPoint = Math.round((advanPoint * parseInt(advan)) / 100);

        for (let j = 0; j < 18; j++) {
          let advantage = parIndexVal?.index_par[j].index <= advanPoint;

          if (i === 0) {
            t1[j] = {
              ...t1[j],
              advantage: advantage,
              par: parIndexVal.index_par[j].par,
              index: parIndexVal.index_par[j].index,
            };
          } else if (i === 1) {
            t2[j] = {
              ...t2[j],
              advantage: advantage,
              par: parIndexVal.index_par[j].par,
              index: parIndexVal.index_par[j].index,
            };
          } else if (i === 2) {
            t3[j] = {
              ...t3[j],
              advantage: advantage,
              par: parIndexVal.index_par[j].par,
              index: parIndexVal.index_par[j].index,
            };
          } else {
            t4[j] = {
              ...t4[j],
              advantage: advantage,
              par: parIndexVal.index_par[j].par,
              index: parIndexVal.index_par[j].index,
            };
          }
        }
      } else {
        for (let j = 0; j < 18; j++) {
          if (i === 0) {
            t1[j] = {
              ...t1[j],
              advantage: false,
              par: parIndexVal.index_par[j].par,
              index: parIndexVal.index_par[j].index,
            };
          } else if (i === 1) {
            t2[j] = {
              ...t2[j],
              advantage: false,
              par: parIndexVal.index_par[j].par,
              index: parIndexVal.index_par[j].index,
            };
          } else if (i === 2) {
            t3[j] = {
              ...t3[j],
              advantage: false,
              par: parIndexVal.index_par[j].par,
              index: parIndexVal.index_par[j].index,
            };
          } else {
            t4[j] = {
              ...t4[j],
              advantage: false,
              par: parIndexVal.index_par[j].par,
              index: parIndexVal.index_par[j].index,
            };
          }
        }
      }
    }

    let mergeArr = {
      group1: [t1, t2],
      group2: [t3, t4],
    };

    return mergeArr;
  }
};
